import React from 'react';
import { Skeleton, SkeletonImage } from 'seduo-ui';
const Example = (props) => (<div>
        <div>
            <Skeleton lines={2} type="hero"/>
            <p>
                <Skeleton lines={3}/>
            </p>
        </div>

        <br />
        <br />

        <div>
            <Skeleton lines={3} type="title"/>
            <p>
                <Skeleton lines={5}/>
            </p>
        </div>

        <SkeletonImage width="500px" height="300px"/>
        <br />
        <SkeletonImage width="50px" height="50px" className="rounded-circle"/>
        <br />
        <div className="bg-brand-dark p-5">
            <Skeleton lines={3} type="title" theme="dark"/>
        </div>
    </div>);
export default Example;
